import React from 'react';
import Modal from '../../../../components/Modal';
import { Row, Column } from '../../../../styles/components';
import { Container, Content } from './styles';

interface TarifasModalProps {
  show: boolean;
  title: string;
  handleClose(): void;
}

const ManualModal: React.FC<TarifasModalProps> = ({
  handleClose,
  show,
  title,
}) => {
  // const [loader, setLoader] = useState<boolean>(true);
  // const service = { CoreService: new CoreService() };
  // const [page, setpage] = useState<number>(1);
  // const [perPage, setPerPage] = useState<number>(50);
  // const [totalRows, setTotalRows] = useState<number>(0);
  // const [filters, setFilters] = useState<ArrayFilters>({
  //   filters: [{ page }, { quantity: perPage }],
  // });
  // const handleChangePerPage = useCallback(
  //   async (newPage: number) => {
  //     setpage(newPage);
  //     setFilters({ filters: [...filters.filters, { page: newPage }] });
  //   },
  //   [filters],
  // );

  // const handleChangeRowsPerPage = useCallback(
  //   async (newPerPage: number, OldPerPage: number) => {
  //     setPerPage(newPerPage);
  //     setpage(OldPerPage);
  //     setFilters({
  //       filters: [
  //         ...filters.filters,
  //         { page: OldPerPage },
  //         { quantity: newPerPage },
  //       ],
  //     });
  //   },
  //   [filters],
  // );
  return (
    <Container>
      <Modal show={show} title={title} handleClose={handleClose}>
        <Row>
          <Column large="12" medium="12" small="12" className="tableContainer">
            <Content>
              <h2>Cadastro de Funcionários</h2>
              <div>
                Funcionários ⇨ Adicionar ⇨ Preencher os campos obrigatórios
                (Nome, Matricula e CPF) ⇨ Salvar Dados.
              </div>
              <h2>Cadastro de Funcionários por Importação</h2>
              <div>
                Funcionários ⇨ Importar ⇨ Escolher Arquivo ⇨ Aguarde a imporação
                ser efetuada com sucesso.
              </div>
              <h2>Alteração de Funcionários</h2>
              <div>
                Funcionários ⇨ Localizar o funcionário ⇨ Clicar em editar
                (lápis) ⇨ fazer as alterações necessárias ⇨ Salvar dados.
              </div>
              <h2>Excluir Funcionário</h2>
              <div>
                Funcionários ⇨ Localizar o funcionário ⇨ Clicar remover
                (lixeira).
              </div>
              <h2>Associação de cartão ao funcionário de forma manual</h2>
              <div>
                Funcionários ⇨ Localizar o funcionário ⇨ Associar cartão ⇨
                Digitar o número do cartão sem o dígito ⇨ Confirmar.
              </div>
              <h2>Associação de cartão ao funcionário de forma Automática</h2>
              <div>
                Funcionários ⇨ Associar cartão ⇨ Confirmar associação
                automática.
              </div>
              <h2>Relatório de Funcionário</h2>
              <div>
                Funcionários ⇨ Gerar relatório (Gerar CSV (Relatório em Excel)
                ou Gerar PDF (Relatório em PDF)).
              </div>
              <h2>Inativar ou Ativar Funcionário</h2>
              <div>
                Funcionários ⇨ Localizar o funcionário ⇨ Clicar em editar
                (lápis) ⇨ Alterar o status conforme desejado ⇨ Salvar dados.
              </div>
              <h2>Criar Departamentos</h2>
              <div>
                Departamentos ⇨ Adicionar Departamentos ⇨ Preencher o nome do
                departamento ⇨ Salvar dados.
              </div>
              <div>
                Após o departamento ter sido criado, editar o funcionário que
                deseja incluir neste novo departamento.
              </div>
              <h2>Saldo dos Cartões</h2>
              <div>
                Meus Cartões ⇨ Localizar o cartão ⇨ Saldo exibido na tela.
              </div>
              <h2>Relatório de Saldo dos Cartões</h2>
              <div>Meus Cartões:</div>
              <div>
                ⇨ Saldo CSV (Relatório em excel de saldo analítico, contendo
                extrato de carga - valor carregado, valor utilizado e saldo
                atual).
              </div>
              <div>
                ⇨ Saldo PDF (Relatório em PDF de saldo analítico, contendo
                extrato de carga - valor carregado, valor utilizado e saldo
                atual).
              </div>
              <div> ⇨ Gerar CSV (Relatório em excel de saldo sintético). </div>
              <div>⇨ Gerar PDF (Relatório em PDF de saldo sintético).</div>
              <h2>Solicitar cartões novos</h2>
              <div>
                Pedido de cartão ⇨ Solicitar cartão ⇨ Aparecerá a tela para
                confirmação e caso confirmar, será solicitado para todos os
                funcionários cadastrados sem cartão associado.
              </div>
              <h2>Relatório de Pedido de cartão</h2>
              <div>
                Pedido de cartão ⇨ Gerar CSV (Relatório em Excel) ou Gerar PDF
                (Relatório em PDF).
              </div>
              <h2>Cartões em multa</h2>
              <div>Sem pedidos por 90 dias Bloqueados sem 2ª via</div>
              <h2>Substituição de cartão</h2>
              <div>Cartões Substituídos ⇨ Localizar pelo número do cartão.</div>
              <h2>Tarifas Vigentes</h2>
              <div>Tarifas por linha.</div>
              <h2>Solicitar carga</h2>
              <div>Pedidos de recarga ⇨ Solicitar recarga ⇨ Por valor.</div>
              <div>
                Após solicitar o valor e confirmar, aparecerá a tela para
                finalizar pedido.
              </div>
              <div>
                Caso tenha departamento, selecione-o e digite o valor desejado.
              </div>
              <div>
                Caso tenha algum funcionário com carga diferente, deverá clicar
                em ver funcionário, editar, digitar o valor e salvar.
              </div>
              <h2>Cancelar pedido</h2>
              <div>
                Pedidos de recarga ⇨ Cancelar (x) ⇨ O pedido retornará ao status
                em andamento, basta clicar em remover.
              </div>
              <h2>Gerar boleto</h2>
              <div>Ao gravar o pedido aparecerá a opção de emitir boleto.</div>
              <div>
                {' '}
                Poderá retirar também em: Pedidos de carga ⇨ Emitir boleto.
              </div>
              <h2>Solicitar carga por importação</h2>
              <div>
                Pedidos de recarga ⇨ solicitar recarga ⇨ por importação ⇨
                Escolher arquivo.
              </div>
              <h2>Extrato de cartões carregados e não carregados</h2>
              <div>Pedidos de recarga ⇨ Gerar CSV ou Gerar PDF.</div>
              <div>Preencher os campos e clicar em gerar relatório.</div>
              <h2>Relatório de recibo de recarga</h2>
              <div>Pedidos de recarga ⇨ Emitir Recibo.</div>
              <h2>Bloqueio de cartão com emissão de segunda via</h2>
              <div>Meus Cartões ⇨ Localizar o cartão ⇨ Bloquear cartão.</div>
              <h2>Desassociar cartão</h2>
              <div>
                Funcionários ⇨ Editar ⇨ Inativar desmarcando a opção de ativo.
              </div>
            </Content>
          </Column>
        </Row>
      </Modal>
    </Container>
  );
};

export default ManualModal;
